import { useLocation, useNavigate } from "react-router-dom";
import { Package, ShoppingCart, BarChart3, Box } from "lucide-react";

const tabs = [
  { label: "Relatório", path: "/estoque/relatorio", icon: BarChart3 },
  { label: "Produtos", path: "/produtos", icon: Package },
  { label: "Estoque", path: "/estoque", icon: Box },
  { label: "Compras", path: "/compras", icon: ShoppingCart },
];

export default function StockNavBar() {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = location.pathname.replace(/^\/admin/, "");

  return (
    // Celular: as 4 abas dividem a largura em grade, ícone em cima do nome.
    // Em linha, passavam de 400px e "Compras" ficava cortada, sem como tocar.
    <div className="grid grid-cols-4 sm:flex gap-1 bg-muted/50 rounded-lg p-1 w-full sm:w-fit mb-6 mx-auto">
      {tabs.map(({ label, path, icon: Icon }) => {
        const isActive = currentPath === path || (path === "/estoque" && currentPath === "/ingredientes");
        return (
          <button
            key={path}
            onClick={() => {
                window.dispatchEvent(new CustomEvent("collapse-sidebar-menus"));
                navigate(`/admin${path}`);
              }}
            className={`flex flex-col sm:flex-row items-center justify-center gap-0.5 sm:gap-1.5 px-1 sm:px-4 py-1.5 sm:py-2 rounded-md text-[11px] sm:text-sm font-medium transition-all ${
              isActive
                ? "bg-background shadow-sm text-foreground"
                : "text-muted-foreground hover:text-foreground"
            }`}
          >
            <Icon className="w-4 h-4" />
            {label}
          </button>
        );
      })}
    </div>
  );
}
